// extracted by mini-css-extract-plugin
module.exports = {"modalButton":"style_modalButton__VX1cs","modalContent":"style_modalContent__TKdb1","modalWrapper":"style_modalWrapper__sgfk7","modalColors":"style_modalColors__RTsrL"};